import { useRef, useEffect } from 'react';
import {  _ProductDetail } from './Products';
interface props {
    pDetailData: _ProductDetail;
}
const ProductDetailTable: React.FC<props> = ({ pDetailData }) => {

    //const myRef = useRef("");
    const tableRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (tableRef.current) {
          
            tableRef.current.innerHTML = pDetailData.size_table;
        }
    }, [pDetailData.size_table]);
    return (
        <div className="overtable" ref={tableRef}/>
    )
}

export default ProductDetailTable;